import React, { useEffect, useState } from 'react';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import AdForm from '../components/AdForm';
import axios from '../api';

import { useLocation } from 'react-router-dom';

const PostAd = ({ selectedCity }) => {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const editId = params.get('edit');
  const [adData, setAdData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    document.title = editId ? 'ویرایش آگهی | آگاه‌جو' : 'ثبت آگهی جدید | آگاه‌جو';
  }, [editId]);

  useEffect(() => {
    if (editId) {
      setLoading(true);
      axios.get(`/ads/${editId}/`)
        .then(res => {
          setAdData(res.data);
          setLoading(false);
        })
        .catch(err => {
          if (err.response) {
            if (err.response.status === 404) {
              setError('آگهی مورد نظر یافت نشد.');
            } else if (err.response.status === 401) {
              setError('دسترسی غیرمجاز. لطفاً دوباره وارد شوید.');
            } else {
              setError('خطا در دریافت اطلاعات آگهی. لطفاً بعداً تلاش کنید.');
            }
          } else {
            setError('ارتباط با سرور برقرار نشد.');
          }
          setLoading(false);
        });
    }
  }, [editId]);

  if (loading) return <div style={{ textAlign: 'center', marginTop: 48 }}>در حال بارگذاری...</div>;
  if (error) return <div style={{ textAlign: 'center', marginTop: 48, color: 'red' }}>{error}</div>;

  return (
    <Box sx={{ direction: 'rtl', display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '60vh', px: 2, py: 8, bgcolor: 'background.default' }}>
      <Paper elevation={6} sx={{ borderRadius: 5, p: { xs: 2, md: 5 }, width: '100%', maxWidth: 600, display: 'flex', flexDirection: 'column', gap: 3, boxShadow: '0 8px 32px 0 rgba(0,30,80,0.12)' }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 2 }}>
          <Box sx={{ bgcolor: 'primary.main', color: 'white', borderRadius: '50%', width: 56, height: 56, display: 'flex', alignItems: 'center', justifyContent: 'center', boxShadow: 2 }}>
            <span style={{ fontSize: 32, fontWeight: 900 }}>+</span>
          </Box>
          <Typography variant="h4" fontWeight={900} color="primary" align="right" sx={{ letterSpacing: 1, textShadow: '0 2px 8px #b3e5fc' }}>
            {editId ? 'ویرایش آگهی' : 'ثبت آگهی جدید'}
          </Typography>
        </Box>
        <Typography variant="subtitle1" color="text.secondary" align="right" sx={{ mb: 2, fontWeight: 500 }}>
          اطلاعات خود را با دقت وارد کنید تا آگهی شما بهتر دیده شود.
        </Typography>
  <AdForm adId={editId || ''} initialData={adData} selectedCity={selectedCity} />
      </Paper>
    </Box>
  );
};

export default PostAd;
